<script setup>
import { ref } from 'vue'
import { getInitials } from '@/utils/strings'
import { getContrastTextColor } from '@/utils/colors'

const props = defineProps({
  employee: {
    type: Object,
  },
  size: {
    type: String,
    default: 'small',
  },
  tooltipText: {
    type: String,
    default: null,
  },
  showTooltip: {
    type: Boolean,
    default: true,
  },
  overrideAvatarInitials: {
    type: String,
    default: null,
  },
  overrideName: {
    type: String,
    default: null,
  },
  horizontal: {
    type: Boolean,
    default: null,
  },
  vertical: {
    type: Boolean,
    default: null,
  },
  maxWidth: {
    type: [Number, String],
    default: 200,
  },
  truncateTwo: {
    type: Boolean,
    default: false,
  },
  truncateThree: {
    type: Boolean,
    default: false,
  },
})

const imageLoadFailed = ref(false)
</script>

<template>
  <div
    :class="{
      'd-flex gap-x-1 gap-y-0 line-height-normal align-center': props.horizontal || props.vertical,
      'flex-column justify-center text-center': props.vertical,
    }"
  >
    <VAvatar
      v-if="props.employee"
      :size="props.size"
      :color="props.employee.deleted ? '' : props.employee.color"
      :class="{ 'employee-avatar--deleted': props.employee.deleted }"
    >
      <span
        v-if="!props.employee.imageSource || imageLoadFailed"
        :style="!props.employee.deleted ? `color: ${getContrastTextColor(props.employee?.color)}` : undefined"
        :class="{'xxs-font-size' : props.size === 'x-small'}"
      >
        {{
          getInitials(
            props.overrideAvatarInitials ||
              props.employee.shortName ||
              props.employee.shortname ||
              props.employee.fullName ||
              props.employee.name ||
              props.employee.title ||
              `${props.employee.firstname || ''} ${props.employee.lastname || ''}`
          )
        }}
      </span>
      <VImg
        v-else
        :src="props.employee.imageSource"
        @error="imageLoadFailed = true"
      />
      <VTooltip
        v-if="props.showTooltip"
        activator="parent"
        location="top"
      >
        {{ props.tooltipText || `${$t('selected_employee')}: ${props.employee.title || props.employee.fullName || props.employee.employeeTitle}` }}
      </VTooltip>
      <slot />
    </VAvatar>
    <span
      class="ml-1"
      :class="{
        'white-space-normal text-truncate-2-lines': props.truncateTwo,
        'white-space-normal text-truncate-3-lines': props.truncateThree,
      }"
      :style="{
        maxWidth: typeof props.maxWidth === 'number'
          ? `${props.maxWidth}px`
          : props.maxWidth,
      }"
    >
      {{ props.overrideName ||
        props.employee.fullName ||
        props.employee.name ||
        props.employee.title ||
        `${props.employee.firstname || ''} ${props.employee.lastname || ''}` ||
        props.employee.shortName ||
        props.employee.shortname
      }}
    </span>
  </div>
</template>

<!--background: #FFE7E7 !important;-->
<!--color: #A32323 !important;-->
<!--border: 1px solid #FAC9C9 !important;-->
